var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19999 13C7.75228 13 8.19999 12.5523 8.19999 12L8.2 8.20001H12C12.5523 8.20001 13 7.75229 13 7.20001V6.80001C13 6.24772 12.5523 5.80001 12 5.80001H8.2L8.2 2C8.2 1.44772 7.75228 1 7.2 1H6.8C6.24771 1 5.8 1.44771 5.8 2L5.8 5.8H2C1.44772 5.8 1 6.24772 1 6.8V7.2C1 7.75229 1.44771 8.2 2 8.2H5.8L5.79999 12C5.79999 12.5523 6.24771 13 6.79999 13H7.19999Z",
    fill: "#A5DACB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.3740fe10d292a618b5411e43bedf6929.svg";
export { ForwardRef as ReactComponent };